// The active tenant's id, or null until it is known.
//
// One line at the call site. Every component that keys a query on the tenant
// used to re-derive `tenant?.tenantId ?? null` itself — two branches of
// cyclomatic noise per component, and nine copies in the labour tabs alone
// after the tenant-key sweep (audit §4.4). Pair it with `enabled: !!tenantId`.

import { useActiveTenant } from '@/lib/useActiveTenant'

export function useActiveTenantId(): string | null {
  const { data } = useActiveTenant()
  return data?.tenantId ?? null
}
